import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b182789"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-panel" }
const _hoisted_2 = { class: "flexible-small-fields customise-fields" }
const _hoisted_3 = { class: "flexible-small-fields customise-fields" }
const _hoisted_4 = { class: "tab-panel" }
const _hoisted_5 = { class: "flexible-small-fields preview-fields" }
const _hoisted_6 = {
  key: 0,
  class: "contact-navigator"
}

import { computed, ref, watch, inject, onMounted, PropType } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import { DxTabPanel, DxItem } from "devextreme-vue/tab-panel";
import AcquaintInfoBox from "../ui/inputs/acquaint-info-box.vue";
import PropertyLookup from "../ui/lookup/property-lookup.vue";
import LookupSingleSelect from "../ui/lookup/lookup-single-select.vue";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import { SMSForm } from "@/types/sms/SMSForm";
import AcquaintTextArea from "../ui/inputs/acquaint-text-area.vue";
import AcquaintInfoTextArea from "../ui/inputs/acquaint-info-text-area.vue";
import { FieldSize } from "@/enums/system/FieldSize";
import displayErrorMessage from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { SMSCredits } from "@/types/sms/SMSCredits";
import { SMSPreviewBody } from "@/types/sms/SMSPreviewBody";
import { SMSTextsValidation } from "acquaint-api/validation/SMSTextsValidation";
import { ContactSummary } from "@/types/contacts/ContactSummary";
import MergeFieldsModal from "../contacts/merge-fields-modal.vue";
import SelectCcContactsModal from "../contacts/select-cc-contacts-modal.vue";
import { SmsTemplates } from "@/enums/SmsTemplates";
import { SmsTemplates as SmsTemplatesInterface } from "@/types/sms/SMSTemplate";
import { SMSFromNumber } from "@/types/sms/SMSFromNumber";
import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";
import { TextboxValueChangeEvent } from "@/enums/ui/inputs/TextboxValueChangeEvent";
import { SystemConfiguration } from "acquaint-api/constants/SystemConfiguration";
import { useSystemConfigurationStore } from "@/stores/SystemConfigurationStore";
import { displayQuestionAlert } from "@/alerts/questionAlert";
import { TemplateContentTypes } from "@/enums/TemplateContentTypes";
import { standardInfoAlert } from "@/alerts/standardInfoAlert";
import AiTextGeneratorModal from "../ai/ai-text-generator-modal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'sms-form',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },

  /**
   * The list of contact IDs.
   * Defaults to an empty array if not provided.
   * @type {number[]}
   * @default []
   */
  contactList: {
    type: Array as PropType<number[]>,
    default: () => [],
  },

  /**
   * The unique identifier for the SMS template.
   * Defaults to -1 if not provided.
   * @type {number}
   * @default -1
   */
  smsTemplate: {
    type: Number,
    default: -1,
  },

  /**
   * The unique identifier for the property.
   * @type {number}
   * @default 0
   */
  propertyId: {
    type: [Number, Array] as PropType<number | number[]>,
    default: 0,
  },

  /**
   * The unique identifier for the certificate.
   * @type {number}
   * @default 0
   */
  certificateId: {
    type: Number,
    default: 0,
  },
  /**
   * The unique identifier for the appointment.
   * @type {number}
   * @default 0
   */
  appointmentId: {
    type: Number,
    default: 0,
  },
  /**
   * The unique identifier for the work order.
   * @type {number}
   * @default 0
   */
  workOrderId: {
    type: Number,
    default: 0,
  },
  /**
   * This is used when texting landlords and tenants per property from the tenancy list screens
   */
  textingContactsPerProperty: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes.
   * This is used to update the v-model variable in the parent component and control the visibility of the modal.
   * @event update:modelValue
   * @property {boolean} value - The updated state to reflect whether the modal should be shown or hidden.
   */
  "update:modelValue",

  /**
   * Triggered when the smsSent operation is successful.
   * This informs the parent component that the operation is success.
   */
  "smsSent",
  /**
   * Emitted when the modal is cancel Prompt Accepted.
   * This can be used to notify the parent component that the cancel Prompt has been Accepted.
   */
  "cancelPromptAccepted",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const smsText = ref<SMSForm>({
  contactId: 0,
  templateId: 0,
  body: "",
  propertyId: 0,
  workOrderId: 0,
  propertyOfferId: 0,
  certificateId: 0,
  tenancyId: 0,
  appointmentId: 0,
  cCs: [],
});
const openSelectCcContactModal = ref(false);
const clearLists = ref(false);
const copyToContacts = ref("");
const previewBody = ref<SMSPreviewBody>({ body: "" });
const selectedTab = ref(1);
const numberOfCredits = ref<SMSCredits>();
const displayMergeFieldsModal = ref(false);
const showCloseConfirmationPrompt = ref(true);
const selectedTemplate = ref<SmsTemplatesInterface>();
const saving = ref(false);
const characterCount = ref(0);
const smsFromNumber = ref<SMSFromNumber>({ fromNumber: "" });
const footer = ref("");
const contactNamesMobile = ref<string[]>([]);
const currentContactPosition = ref(0);
const selectedContactId = ref(0);
const apiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const apiNextClient = inject("AcquaintApiNextClient") as AcquaintApiNextClient;
const systemConfigurationStore = useSystemConfigurationStore();
const contactSummary = ref<ContactSummary>();
const displayAIModal = ref(false);
const previouslyNavigatedThroughIds = ref<number[]>([]);
const modalTitle = ref("Send SMS Text - Default sms");
const furthestContactVisited = ref(0);

// Logic for fetching the initial data to be displayed
onMounted(() => {
  fetchSmsFromNumber();
});

watch(
  () => showModal.value,
  async () => {
    if (!showModal.value) {
      clearLists.value = true;
      setTimeout(() => {
        clearLists.value = false;
      }, 100);
      return;
    }
    furthestContactVisited.value = 0;
    selectedTab.value = 0;
    currentContactPosition.value = 0;
    let property = 0;
    if (Array.isArray(props.propertyId) && props.propertyId.length > 0) {
      property = props.propertyId[0];
    } else if (
      Array.isArray(props.propertyId) &&
      props.propertyId.length == 0
    ) {
      property = 0;
    } else if (!Array.isArray(props.propertyId)) {
      property = props.propertyId;
    }

    smsText.value = {
      contactId: props.contactList.length > 1 ? 0 : props.contactList[0],
      templateId:
        props.smsTemplate > -1 ? props.smsTemplate : SmsTemplates.DefaultSms,
      body: "",
      propertyId: property,
      workOrderId: props.workOrderId,
      propertyOfferId: 0,
      certificateId: props.certificateId,
      tenancyId: 0,
      appointmentId: props.appointmentId,
      cCs: [],
    };
    previouslyNavigatedThroughIds.value = [];
    contactSummary.value = undefined;
    contactNamesMobile.value = [];
    footer.value = await systemConfigurationStore.getSystemConfigurationValue(
      SystemConfiguration.SMSFooter,
    );
    setBodyValue();
    characterCount.value = 0;
    showCloseConfirmationPrompt.value = true;
    selectedContactId.value =
      props.contactList.length > 0 ? props.contactList[0] : 0;

    // When the modal is opened from the property page, multiple contacts can be provided.
    // When a contact is opened from a contact page, only one contact is provided
    if (props.contactList.length > 0) {
      updatedNamesTextList(props.contactList[0]);
    }

    previewBody.value = { body: "" };
    copyToContacts.value = "";
    fetchSmsCredits();
  },
);

const updatedNamesTextList = async (contactId: number) => {
  const summary: ContactSummary | undefined =
    await fetchSendToContactData(contactId);

  if (!summary) {
    return;
  }

  contactNamesMobile.value.push(`${summary.name} - ${summary.mobileNumber}`);
  contactSummary.value = summary;

  if (!contactSummary.value || contactSummary.value.mobileNumber == "") {
    await standardInfoAlert(
      `${summary?.name} has no mobile number and cannot be texted.`,
    );
  }
};

const fetchSendToContactData = async (id: number) => {
  try {
    return await apiClient.httpGet<ContactSummary>(
      `app/contacts/${id}/summary`,
    );
  } catch (ex) {
    displayErrorMessage(getErrorMessage(ex));
    return undefined;
  }
};

const fetchSmsFromNumber = async () => {
  try {
    smsFromNumber.value = await apiNextClient.httpGet("Sms/settings");
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    smsFromNumber.value = { fromNumber: "" };
  }
};

const fetchSmsCredits = async () => {
  try {
    numberOfCredits.value = await apiClient.httpGet(
      "app/correspondence/sms/credits",
    );
    return true;
  } catch (err) {
    numberOfCredits.value = undefined;
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

// This sets some of the data displayed in the modal that cannot be changed
const messageLengthWarning = computed(() =>
  smsText.value.body.length > 160 ? "Will be sent as multiple texts" : "",
);

const displayedNumberOfCredits = computed(() => {
  return numberOfCredits.value ? numberOfCredits.value.total.toString() : "";
});

const templateUpdated = (templateDescription: string) => {
  const modalTitleArray = modalTitle.value.split("-");

  const newTitle = `${modalTitleArray[0]} - ${templateDescription}`;

  modalTitle.value = newTitle;
};

const bodyChanged = (message: string) => {
  if (!message || typeof message != "string") {
    return;
  }
  characterCount.value = message.length;
};

// Disables the send button under certain conditions
const sendButtonDisabled = computed(() => {
  return (
    smsText.value?.body.length == 0 ||
    saving.value ||
    !numberOfCredits.value ||
    numberOfCredits.value.total <= 0 ||
    contactNamesMobile.value.length == 0 ||
    !contactSummary.value ||
    contactSummary.value.mobileNumber == ""
  );
});

// Logic for sending texts
const onSendClick = async () => {
  if (
    selectedTemplate.value?.contentTypeID == TemplateContentTypes.Marketing &&
    contactSummary.value &&
    !contactSummary.value.marketingPreferences.smsText
  ) {
    const alert = await displayQuestionAlert(
      "This Contact has not subscribed to receive Marketing correspondence from you. If you continue you may be breaching regulations. Are you sure you want to continue?",
    );

    if (!alert.isConfirmed) {
      return;
    }
  }

  saving.value = true;

  const endpointRequest: SMSForm[] = props.contactList.map(
    (contactId, index) => {
      return {
        contactId: contactId,
        templateId: smsText.value.templateId,
        body: smsText.value.body,
        propertyId: returnPropertyId(index),
        workOrderId: smsText.value.workOrderId,
        propertyOfferId: smsText.value.propertyOfferId,
        certificateId: smsText.value.certificateId,
        tenancyId: smsText.value.tenancyId,
        appointmentId: smsText.value.appointmentId,
        cCs: [...smsText.value.cCs],
      };
    },
  );

  if (await sendSMS(endpointRequest)) {
    showCloseConfirmationPrompt.value = false;
    showModal.value = false;
    emit("smsSent");
  }
  saving.value = false;
};

const sendSMS = async (endpointRequest: SMSForm[]) => {
  try {
    await apiNextClient.httpPostVoid("/Sms/queue", endpointRequest);
    return true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

// Logic for adding a merge field to the text
const openMergeFieldsModal = () => {
  displayMergeFieldsModal.value = true;
};

const addMergeField = (mergeField: String) => {
  const textArea: HTMLInputElement | null = document.querySelector(
    "#sms-message-container > .dx-textbox > .dx-texteditor-container > .dx-texteditor-input-container > textarea",
  );

  if (!textArea) {
    return;
  }

  // Get the current cursor position
  const startPos = textArea.selectionStart;
  const endPos = textArea.selectionEnd;

  // Get the current value of the textarea
  const value = textArea.value;

  if (typeof startPos != "number" || typeof endPos != "number") {
    return;
  }

  // Insert the text at the cursor position
  textArea.value =
    value.substring(0, startPos) + `[${mergeField}]` + value.substring(endPos);
  smsText.value.body = textArea.value;

  // Move the cursor to the end of the inserted text
  textArea.focus();
  textArea.selectionStart = textArea.selectionEnd =
    startPos + mergeField.length + 2;

  characterCount.value = smsText.value.body.length;
};

// This fetches the preview text everytime the user updates the text body
watch(
  () => smsText.value.body,
  () => {
    fetchPreviewBody();
  },
);

const fetchPreviewBody = async () => {
  try {
    previewBody.value = await apiClient.httpPost(
      "app/correspondence/sms/preview",
      previewParamaters.value,
    );
  } catch (err) {
    previewBody.value = { body: "" };
    displayErrorMessage(getErrorMessage(err));
  }
};

const previewParamaters = computed(() => {
  return {
    contactId: selectedContactId.value,
    templateId: smsText.value.templateId,
    body: smsText.value.body,
    propertyId: smsText.value.propertyId,
    workOrderId: smsText.value.workOrderId,
    propertyOfferId: smsText.value.propertyOfferId,
    certificateId: smsText.value.certificateId,
    tenancyId: smsText.value.tenancyId,
    appointmentId: smsText.value.appointmentId,
    cCs: smsText.value.cCs,
  };
});

// Logic for letting users select a CC contact
const selectCopyToContacts = () => {
  if (props.contactList.length > 1) {
    return true;
  }
  openSelectCcContactModal.value = true;
};

const updateCopyToContacts = (
  contacts: string,
  contactNamesMobile: string,
  copyToContactIds: number[],
) => {
  copyToContacts.value = contacts;
  smsText.value.cCs = copyToContactIds;
};

// This fetches a text configuration and adds it to the text's body
watch(
  () => smsText.value.templateId,
  () => {
    setBodyValue();
  },
);

const setBodyValue = async () => {
  await fetchSelectedTemplate();

  if (selectedTemplate.value) {
    /* As new lines from the api contain \r\n due to the api being hosted in a Windows environment
     * We must replace them with \n, otherwise the character count gets out of sync */
    smsText.value.body = selectedTemplate.value.body.replace(/\r\n/g, "\n");
  }

  smsText.value.body = `${smsText.value.body} ${footer.value}`;
};

const fetchSelectedTemplate = async () => {
  try {
    selectedTemplate.value = await apiClient.httpGet(
      `database/smstexts/${smsText.value.templateId}`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    selectedTemplate.value = undefined;
  }
};

// Functions for when users navigate through contacts on the preview tab
// The preview body must be updated whenever the displayed contact is changed
watch(
  () => currentContactPosition.value,
  (newVal, oldVal) => {
    smsText.value.propertyId = returnPropertyId(currentContactPosition.value);
    selectedContactId.value = props.contactList[currentContactPosition.value];

    // We don't want to update the contactNamesEmails list with the same contact info twice or more often unless we are
    // emailing contacts per property as a contact may be texted multipled times if they
    // associated with multiple properties.
    // Also this is only triggered when a moving forward through contacts, not backwards then forwards
    // Otherwise, a contact may be incorrectly displayed in the to field on the preview tab

    if (
      (!props.textingContactsPerProperty &&
        !previouslyNavigatedThroughIds.value.find((id) => {
          return id == selectedContactId.value;
        })) ||
      (props.textingContactsPerProperty &&
        newVal > oldVal &&
        newVal > furthestContactVisited.value)
    ) {
      furthestContactVisited.value = newVal;
      updatedNamesTextList(selectedContactId.value);
      previouslyNavigatedThroughIds.value.push(selectedContactId.value);
    }
    fetchPreviewBody();
  },
);

const displayPreviousContact = () => {
  if (currentContactPosition.value == 0) {
    return;
  }

  currentContactPosition.value--;
};

const displayNextContact = () => {
  if (currentContactPosition.value == props.contactList.length - 1) {
    return;
  }

  currentContactPosition.value++;
};

// This adds AI generated code to the text's body
const appyAIText = (aiText: string) => {
  smsText.value.body = aiText;
};

// Logic for closing the modal
const cancelPromptAccepted = () => {
  emit("cancelPromptAccepted");
  showModal.value = false;
};

const onCancelClick = () => (showModal.value = false);

// This calculates the property id for each text
// In the tenancy list, users may want to text tenants and landlords per property
// and so the property id must be set correctly for each contact.
const returnPropertyId = (position: number) => {
  if (Array.isArray(props.propertyId) && props.propertyId.length > 0) {
    return props.propertyId[position];
  } else if (Array.isArray(props.propertyId) && props.propertyId.length == 0) {
    return 0;
  } else if (!Array.isArray(props.propertyId)) {
    return props.propertyId;
  }

  return 0;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalBase, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showModal).value = $event)),
      saving: saving.value,
      title: modalTitle.value,
      showCloseConfirmationPrompt: showCloseConfirmationPrompt.value,
      height: "770px",
      customCloseConfirmationText: "Are you sure you want to close this SMS Text without sending?",
      "help-page": "sms-texts",
      onCancelPromptAccepted: cancelPromptAccepted
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(DxTabPanel), {
          "scroll-by-content": true,
          "show-nav-buttons": true,
          "swipe-enabled": false,
          selectedIndex: selectedTab.value,
          "onUpdate:selectedIndex": _cache[4] || (_cache[4] = ($event: any) => ((selectedTab).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(DxItem), { title: "Customise" }, {
              default: _withCtx(() => [
                _createElementVNode("section", _hoisted_1, [
                  _createVNode(AcquaintInfoBox, {
                    text: contactNamesMobile.value[currentContactPosition.value],
                    label: "To"
                  }, null, 8, ["text"]),
                  _createVNode(AcquaintInfoBox, {
                    text: copyToContacts.value,
                    label: "Copy To (CC)",
                    icon: "spindown",
                    onIconClicked: selectCopyToContacts
                  }, null, 8, ["text"]),
                  _createVNode(LookupSingleSelect, {
                    label: "Template",
                    lookupSource: _unref(LookupTableSource).SMSTemplates,
                    modelValue: smsText.value.templateId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((smsText.value.templateId) = $event)),
                    onValueChanged: templateUpdated
                  }, null, 8, ["lookupSource", "modelValue"]),
                  _createVNode(AcquaintTextArea, {
                    label: "Message",
                    modelValue: smsText.value.body,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((smsText.value.body) = $event)),
                    "container-id": "sms-message-container",
                    "field-validation": _unref(SMSTextsValidation).Body,
                    onOnOptionChanged: bodyChanged,
                    "display-a-i-modal": true,
                    valueChangeEvent: _unref(TextboxValueChangeEvent).KeyUp,
                    height: "11.5rem",
                    onAiIconClick: _cache[2] || (_cache[2] = () => (displayAIModal.value = true))
                  }, null, 8, ["modelValue", "field-validation", "valueChangeEvent"]),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(AcquaintInfoBox, {
                      text: smsFromNumber.value.fromNumber,
                      label: "From",
                      width: _unref(FieldSize).Small
                    }, null, 8, ["text", "width"]),
                    _createVNode(AcquaintInfoBox, {
                      text: displayedNumberOfCredits.value,
                      label: "Credits",
                      width: _unref(FieldSize).Small
                    }, null, 8, ["text", "width"])
                  ]),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(AcquaintInfoBox, {
                      text: characterCount.value.toString(),
                      label: "Characters Typed",
                      width: _unref(FieldSize).Small
                    }, null, 8, ["text", "width"]),
                    _createVNode(AcquaintInfoBox, {
                      text: messageLengthWarning.value,
                      width: _unref(FieldSize).Medium
                    }, null, 8, ["text", "width"])
                  ]),
                  _createVNode(PropertyLookup, {
                    modelValue: smsText.value.propertyId,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((smsText.value.propertyId) = $event)),
                    label: "Property Related To"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(DxItem), { title: "Preview" }, {
              default: _withCtx(() => [
                _createElementVNode("section", _hoisted_4, [
                  _createVNode(AcquaintInfoBox, {
                    text: contactNamesMobile.value[currentContactPosition.value],
                    label: "To"
                  }, null, 8, ["text"]),
                  _createVNode(AcquaintInfoTextArea, {
                    label: "Message",
                    text: previewBody.value.body,
                    height: "9rem"
                  }, null, 8, ["text"]),
                  _createElementVNode("div", _hoisted_5, [
                    (props.contactList.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("i", {
                            class: "fas fa-chevron-left",
                            onClick: displayPreviousContact
                          }),
                          _createElementVNode("span", null, _toDisplayString(currentContactPosition.value + 1) + "/" + _toDisplayString(props.contactList.length), 1),
                          _createElementVNode("i", {
                            class: "fas fa-chevron-right",
                            onClick: displayNextContact
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(AcquaintInfoBox, {
                      text: displayedNumberOfCredits.value,
                      label: "Credits",
                      width: _unref(FieldSize).Small
                    }, null, 8, ["text", "width"])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["selectedIndex"])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "before",
          options: {
          text: 'Insert Field',
          onClick: () => {
            openMergeFieldsModal();
          },
          saving: saving.value,
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Send',
          onClick: () => {
            onSendClick();
          },
          disabled: sendButtonDisabled.value,
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Cancel',
          onClick: () => {
            onCancelClick();
          },
          disabled: saving.value,
        }
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["modelValue", "saving", "title", "showCloseConfirmationPrompt"]),
    _createVNode(AiTextGeneratorModal, {
      modelValue: displayAIModal.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((displayAIModal).value = $event)),
      onApplyAIResponse: appyAIText,
      displayApplyButton: true
    }, null, 8, ["modelValue"]),
    _createVNode(MergeFieldsModal, {
      modelValue: displayMergeFieldsModal.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((displayMergeFieldsModal).value = $event)),
      onAddMergeField: addMergeField
    }, null, 8, ["modelValue"]),
    _createVNode(SelectCcContactsModal, {
      modelValue: openSelectCcContactModal.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((openSelectCcContactModal).value = $event)),
      onSaveCopyToContacts: updateCopyToContacts,
      copyTo: true,
      clearLists: clearLists.value,
      forEmail: false,
      "contact-id": selectedContactId.value,
      isPrimaryContact: contactSummary.value?.isPrimaryContact ?? false
    }, null, 8, ["modelValue", "clearLists", "contact-id", "isPrimaryContact"])
  ], 64))
}
}

})